import { Component, Input } from '@angular/core';

@Component({
  selector: 'show-data-input',
  templateUrl: './show-data-input.component.html',
  styleUrls: ['./show-data-input.component.scss']
})
export class ShowDataInputComponent {
  @Input()
  public label: string;

  @Input()
  public class?: string;

  @Input()
  public suffix?: string;

  @Input()
  public iconSize = 'normal';
}
